import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { getConfig } from '@/lib/config'
import { PricingPlanActionType, PricingPlanItem } from '@/shared/api-generated-types'
import TogglePricingVariation from '@/widgets/TogglePricingVariation'
import * as styles from './style'

const { publicRuntimeConfig } = getConfig()

const PricingPlanCard = ({
  title,
  subtitle,
  features,
  pricing,
  iconUrl,
  highlighted,
  featuresTitle,
  primaryAction,
}: PricingPlanItem): JSX.Element => {
  return (
    <div className={styles.root}>
      <div className={styles.detail}>
        {highlighted ? (
          <div className={styles.recommendedTag}>
            <Text size="xxs" weight="lg">
              {highlighted.label}
            </Text>
          </div>
        ) : null}

        <div className={styles.row}>
          {iconUrl ? <img src={iconUrl} className={styles.icon} alt={title} /> : null}

          <Text size="lg" weight="lg" className={styles.title}>
            {title}
          </Text>
          {subtitle ? (
            <Text size="xs" weight="sm" className="pb-sm">
              {subtitle}
            </Text>
          ) : null}
        </div>

        {pricing ? <TogglePricingVariation pricing={pricing} primaryAction={primaryAction} /> : null}

        {primaryAction && primaryAction.type === PricingPlanActionType.Link ? (
          <Button
            component="link"
            size="md"
            target={primaryAction.url.includes(publicRuntimeConfig.website.url) ? '_self' : '_blank'}
            theme="primary"
            href={primaryAction.url}
            label={primaryAction.label}
          />
        ) : null}

        {primaryAction && primaryAction.type === PricingPlanActionType.SelectedLink ? (
          <Button
            component="link"
            size="md"
            theme="green"
            target={primaryAction.url.includes(publicRuntimeConfig.website.url) ? '_self' : '_blank'}
            href={primaryAction.url}
            label={primaryAction.label}
          />
        ) : null}
      </div>
      <div className={styles.info}>
        {featuresTitle && (
          <div className="pb-xs">
            <Text size="xs" weight="lg">
              {featuresTitle}
            </Text>
          </div>
        )}
        {features.map((feature, index) => (
          <Stack x key={index} justifyContent="flex-start">
            <Icon name="checks" size={18} className="pr-md" />
            <Text size="xs" weight="sm" className="pb-sm">
              {feature}
            </Text>
          </Stack>
        ))}
      </div>
    </div>
  )
}

export default PricingPlanCard
